// ä¸è¬ç¨äº ecp-flex-tcb,ecp-flex-lcr çå­ç»ä»¶

import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'ecp-module-title',
    templateUrl: './module-title.component.html',
    styleUrls: ['./module-title.component.css']
})
export class ModuleTitleComponent implements OnInit {
    isShowHelpInfo = false;
    showList = null;
    mouseOut() {
        let seft = this;
        seft.showList = setTimeout(function () {
            seft.isShowHelpInfo = false;
        }, 200);
    }

    cleanTime() {
        let seft = this;
        clearTimeout(seft.showList);
    }
    constructor() {
    }

    ngOnInit() {
    }

}
